import React, { useEffect, useRef, useState } from "react";
import { Select, Typography } from "antd";
import "./FiltersPanel.css";
import { ConceptTypeVolume } from "../../../constants";

const { Paragraph } = Typography;

export const ConceptsFilterContent = ({
    metadata,
    // For Concepts
    onConceptsChange,
    deselect = false,
    onConceptsDeselection,
    // For Concepts List
    sentimentDisabled,
    setConceptList,
    conceptTypeDay,
    handleChangeType,
    setSelectedLocalConcepts,
    resetType
    
}) => {
    // For Concepts
    const prevSelectedConceptsRef = useRef([]);
    const conceptsOptions =
        metadata?.concepts?.options?.map(({ name }) => ({
            value: name,
            label: name,
        })) || [];

    useEffect(() => {
        prevSelectedConceptsRef.current = metadata?.concepts?.selected;
    }, [metadata?.concepts?.selected]);

    const handleChangeConcepts = (newSelectedConcepts) => {
        const previousSelectedConcepts = prevSelectedConceptsRef.current || [];
        if (deselect) {
            const deselectedConcepts = previousSelectedConcepts.filter(
                (concept) => !newSelectedConcepts.includes(concept)
            );
            onConceptsDeselection(deselectedConcepts);
        }
        onConceptsChange(newSelectedConcepts);
    };

    // For Concept Lists
    const [selectedValue, setSelectedValue] = useState(
        metadata?.conceptList?.selected
            ? metadata?.conceptList?.selected
            : `Type: ${conceptTypeDay}`
    );

    useEffect(() => {
        if (metadata?.conceptList?.selected) {
            setSelectedValue(metadata?.conceptList?.selected);
        } else if (conceptTypeDay) {
            setSelectedValue(`Type: ${conceptTypeDay}`);
        }
    }, [metadata?.conceptList?.selected, conceptTypeDay]);

    let conceptTypeOptions = Object.values(ConceptTypeVolume).map((type) => ({
        label: type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
        value: `Type: ${type}`,
    }));

    const conceptListOptions = metadata?.conceptList?.options?.map((list) => ({
        label: list.name + ` (${list.concepts.length})`,
        value: list.concept_list_id,
    }));

    if (sentimentDisabled) {
        conceptTypeOptions = conceptTypeOptions.filter(
            (option) => option.value !== "Type: sentiment_suggested"
        );
    }
    
    const handleChangeConceptLists = (value) => {
        let isTypeOption = false;
        if (!Array.isArray(value)) {
            isTypeOption = value.startsWith("Type: ");
        }

        if (isTypeOption) {
            const typeValue = value.replace("Type: ", "");
            handleChangeType(typeValue);
            // setConceptList(null);
            setSelectedValue(`Type: ${typeValue}`);
        } else {
            setConceptList(value);
            setSelectedLocalConcepts([]);
            setSelectedValue(value);
            if (resetType) resetType(null);
        }
    };

    return (
        <div>
            <div className="filters-val">
                <Paragraph style={{ marginBottom: "4px", color: "#090A09" }}>
                    Select Concepts
                </Paragraph>
                <Select
                    value={metadata?.concepts?.selected}
                    mode="multiple"
                    maxTagCount={0}
                    style={{ width: "100%" }}
                    rootClassName="custom-select"
                    options={conceptsOptions}
                    onChange={handleChangeConcepts}
                ></Select>
            </div>
            <div className="filters-val">
                <Paragraph style={{ marginBottom: "4px", color: "#090A09" }}>
                    Concept Lists
                </Paragraph>
                <Select
                    value={selectedValue}
                    style={{ width: "100%" }}
                    rootClassName="custom-select"
                    maxTagCount={0}
                    options={[
                        {
                            label: <span>Concept Types</span>,
                            options: conceptTypeOptions,
                        },
                        {
                            label: <span>Concept Lists</span>,
                            options: conceptListOptions,
                        },
                    ]}
                    onChange={handleChangeConceptLists}
                ></Select>
            </div>
        </div>
    );
};
